import { render, staticRenderFns } from "./respuesta.vue?vue&type=template&id=008df5fc&scoped=true"
import script from "./respuesta.vue?vue&type=script&lang=js"
export * from "./respuesta.vue?vue&type=script&lang=js"
import style0 from "./respuesta.vue?vue&type=style&index=0&id=008df5fc&prod&scoped=true&lang=css"
import style1 from "./respuesta.vue?vue&type=style&index=1&id=008df5fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008df5fc",
  null
  
)

export default component.exports